import type { FreelancerAvailaleJobsLocales } from '../types';

const freelancerAvailableJobsLocales: FreelancerAvailaleJobsLocales = {
  accept: 'Accepteren',
  allAssignments: 'Alle opdrachten',
  allDistances: 'Alle afstanden',
  allServices: 'Alle diensten',
  applyFilters: 'Filters toepassen',
  assignment: 'opdracht',
  assignments: 'Opdrachten',
  assignmentsOnThisDate: {
    one: 'Je hebt %{count} opdracht op deze datum!',
    other: 'Je hebt %{count} Opdrachten op deze datum!',
    zero: 'je hebt geen opdrachten op deze datum.',
  },
  availability: 'Beschikbaarheid',
  availableOnly: 'Alleen beschikbare dagen',
  competences: 'Competenties',
  confirmAccept: 'Wil je deze dienst accepteren?',
  confirmInterest: 'Wil je interesse tonen in deze dienst?',
  confirmInterestPeriod: 'Wil je interesse tonen in deze diensten?',
  confirmRefuse: 'Wil je deze dienst weigeren?',
  confirmRefusePeriod: 'Wil je deze diensten weigeren?',
  derivedJobMessage:
    'Deze opdracht is afkomstig van een lange opdracht die aan jou is toegewezen.',
  details: 'Details',
  done: 'Gedaan!',
  feedbackAcceptError: 'Opdracht niet meer beschikbaar!',
  feedbackAcceptSuccess: 'Opdracht geaccepteerd!',
  feedbackInterestSuccess: 'Succesvol afgerond!',
  filter: 'Filter',
  home: 'Home',
  interest: 'Keuze',
  interestAssignments: 'Keuze invaldiensten',
  interested: 'Interesse',
  invoices: 'Facturen',
  kilometer: 'kilometer',
  kindOfAssignment: 'Soort opdracht',
  logout: 'Logout',
  longerAssignment: 'Lange opdracht',
  longerAssignments: 'Langere opdrachten',
  minimumHourlyRate: 'Minimaal uurtarief',
  name: 'Naam...',
  newAssignments: 'Nieuwe opdrachten',
  noAvailableJobs: 'Er zijn op dit moment geen opdrachten beschikbaar.',
  noAvailablePeriodJobs:
    'Er zijn op dit moment geen lange opdrachten beschikbaar.',
  noCertificatesRequired: 'Geen certificaten vereist',
  noResultsFound: 'Geen resultaten gevonden',
  notVerified: 'Profiel nog niet geverifieerd.',
  organisation: 'Organisatie',
  personal: 'Persoonlijk',
  personalAssignments: 'Persoonlijke opdrachten',
  personalJobsNotification: {
    one: 'U heeft %{count} openstaande persoonlijke opdracht, klik hier om het filter in te schakelen.',
    other:
      'U heeft %{count} openstaande persoonlijke opdrachten, klik hier om het filter in te schakelen.',
  },
  postCode: 'Postcode',
  setAvailability:
    'Je hebt je zelf nog niet als beschikbaar opgegeven op datum {{date}}. Wil je jezelf op die dag op beschikbaar zetten?',
  settings: 'Instellingen',
  singleCalls: 'Losse oproepen',
  speed: 'Spoed',
  toAsk: 'Vragen',
  toCallToAction: 'Oproepen',
  toInvite: 'Uitnodigen',
  toRefuse: 'Weigeren',
  travelDistance: 'Reisafstand',
  urgentAssignments: 'Spoed invaldiensten',
  wholeDays: 'Hele dagen',
};

export default freelancerAvailableJobsLocales;
